import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=bf2ee542&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=bf2ee542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2ee542",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf2ee542')) {
      api.createRecord('bf2ee542', component.options)
    } else {
      api.reload('bf2ee542', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=bf2ee542&scoped=true&", function () {
      api.rerender('bf2ee542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bW5QCUA7qngW/JS/comp/DateRangeExt.vue"
export default component.exports